




































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Locales } from "@/i18n/locales";
import { VueEditor } from "vue2-editor";

@Component({
  components: {
    VueEditor,
  },
})
export default class LanguageManagerFormComponent extends Vue {
  @Prop() languageDialog!: boolean;
  @Prop() field!: string;
  @Prop() id!: string;
  @Prop() table!: string;
  @Prop() htmlEditor!: boolean;

  englishText: string = "";
  frenchText: string = "";
  spanishText: string = "";

  snackbar: boolean = false;
  message: string = "";
  snackBarColor: string = "red";

  toobarOptions = [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link"], // remove formatting button
  ];

  mounted() {
    this.get();
  }

  // Close modal dialog
  close() {
    this.$emit("close");
  }

  // Get muli-lingual text
  get() {
    var self = this;
    let entity: any = {};
    entity.Id = this.id;
    entity.Table = this.table;
    entity.Field = this.field;

    let url: string = `/api/LanguageManager/GetText/${entity.Id}`;

    this.$services.languageManager.getTableData(url, entity).then((resp) => {
      if (resp && resp.Result === "OK") {
        this.englishText = resp.Record.EnglishText;
        this.frenchText = resp.Record.FrenchText;
        this.spanishText = resp.Record.SpanishText;
      } else {
        self.snackbar = true;
        self.snackBarColor = "red";
        self.message = resp.Message;
      }
    });
  }

  // Update language
  update() {
    var self = this;
    let entity: any = {};
    entity.Id = this.id;
    entity.Table = this.table;
    entity.Field = this.field;
    entity.EnglishText = this.englishText;
    entity.FrenchText = this.frenchText;
    entity.SpanishText = this.spanishText;

    let url: string = `/api/LanguageManager/UpdateText/${entity.Id}`;

    this.$services.languageManager.updateTableData(url, entity).then((resp) => {
      if (resp && resp.Result === "OK") {
        self.snackbar = true;
        self.snackBarColor = "green";
        self.message = "Updated successfully.";
        this.$emit("updated", entity);
      } else {
        self.snackbar = true;
        self.snackBarColor = "red";
        self.message = resp.Message;
      }
    });
  }
}
